import { render, staticRenderFns } from "./ResearchIncomeList.vue?vue&type=template&id=3b8e8c80&scoped=true&"
import script from "./ResearchIncomeList.vue?vue&type=script&lang=js&"
export * from "./ResearchIncomeList.vue?vue&type=script&lang=js&"
import style0 from "./ResearchIncomeList.vue?vue&type=style&index=0&id=3b8e8c80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8e8c80",
  null
  
)

export default component.exports